export const localText = {
  title: 'Filters',
  back: 'Back',
  apply: 'Apply',
  clear: 'Clear',
  noChangesTooltip: 'No changes to update',
} as const
